export default "__VITE_ASSET__BmEV1yVj__"